import { Wallet } from 'lucide-react';
import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function LoadWalletNode({ id, data, selected }) {
  const summary = data.walletLabel
    ? `${data.walletLabel} (${data.network || 'Ethereum'})`
    : data.inputType
      ? `Via ${data.inputType}`
      : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.wallet}
      icon={Wallet}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
      {data.walletLabel && (
        <span className="inline-block mt-1 text-[10px] font-medium bg-purple-100 text-purple-700 px-2 py-0.5 rounded-full">
          {data.walletLabel}
        </span>
      )}
    </BaseNode>
  );
}
